export default __webpack_public_path__ + "static/media/weekend-2019.b6af7ffd.jpg";